import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=d9a57418&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=d9a57418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a57418",
  null
  
)

export default component.exports